// deps
import React, { memo } from "react";

// components
import { EMICardPlaceholder } from "@swiggy-private/dls-web-recipe-common-web/dist/components/EMICard";

// styles
import { EmiContainer, Separator } from "./EMIPlanList.styled";

interface EMIListLoaderProps {
    count?: number;
}

const EMIListLoader = ({ count = 10 }: EMIListLoaderProps) => {
    return (
        <EmiContainer>
            {Array.from({ length: count }).map((_, index) => (
                <React.Fragment key={index}>
                    <EMICardPlaceholder />
                    {index !== count - 1 && <Separator />}
                </React.Fragment>
            ))}
        </EmiContainer>
    );
};

export default memo(EMIListLoader);
